module.exports = __webpack_public_path__ + "static/mondays-infinite-8ee978c95f2fae9dd6297eea03a3d53d.gif";